import { getLocale } from '#/paraglide/runtime'
import { TUTORIAL_EN } from './tutorial-content.en'
import { TUTORIAL_ID } from './tutorial-content.id'
import type { TutorialContent } from './tutorial-types'

/** Content for the visitor's locale (paraglide cookie strategy), same pattern as `/docs`. */
export function tutorialContent(): TutorialContent {
  return getLocale() === 'id' ? TUTORIAL_ID : TUTORIAL_EN
}

export { SECTION_IDS } from './tutorial-types'
export type { TutorialContent }
